module.exports = __webpack_public_path__ + "static/image/font/pc/bmyeonsung-1@3x.jpg?acfe052f";